//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateNotasCredito } from "@/typings/store/plugins/easyFirestore/notasCredito";

const getters: GetterTree<StateNotasCredito, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const notasCredito = {
  firestorePath: "dev/v1/notasCredito",
  firestoreRefType: "collection",
  moduleName: "notasCredito",
  statePropName: "all",
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: "%convertTimestamp%", // default
      updated_at: "%convertTimestamp%", // default
    },
  },
  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default notasCredito;
